// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1Zqes","content":"RecentSearches_content__2lZYs"};